import { createContext } from "react"

import { noop } from "shared/lib/noop"

import { TeamListModel } from "./TeamList"

export interface TeamListViewContextType
  extends Pick<
    TeamListModel,
    "userID" | "handlers" | "getTeamHref" | "onTeamSelect"
  > {}

const defaultValue: TeamListViewContextType = {
  userID: null,

  getTeamHref: () => "#",
  onTeamSelect: noop
}

export const TeamListViewContext = createContext(defaultValue)
